import React from 'react';
import AnalyticsPipelineRisk from './AnalyticsPipelineRisk/AnalyticsPipelineRisk';

const PipelineRisk = ({ isRTL = false, companyUID = '', analyticsActorId = 'system' }) => (
  <AnalyticsPipelineRisk isRTL={isRTL} companyUID={companyUID} analyticsActorId={analyticsActorId} />
);

export default PipelineRisk;
